import { Route, Routes } from "react-router-dom"
import {
  AddSubscriptionSteps,
  ClientDetails,
  Clients,
  ClientSubscriptions,
  ClientTransactions,
  Invoices,
  CompanyDetails,
} from "@/constants/lazyLoad/lazyClients"
import AddClientStepper from "@/views/clients/AddClient/AddClientStepper"
import { CLIENT_ADD_STEPS } from "@/types/StepForm"
import React from "react"
import StepEnterprise2 from "@/views/dashboard/components/StepEntreprise"
import ClientLegalRepresentatives from "@/views/clients/clientDetails/tabs/ClientLegalRepresentatives"

const ClientsRoutes = () => {
  
  return (
    <Routes>
      <Route index element={<Clients />} />
      <Route path="infos/:id/*" element={<ClientDetails />} >
          <Route
            index
            element={
              <CompanyDetails
                // subscription={subscription}
                // activeUserCount={activeUserCount}
              />
            }
          />
          <Route path={`finances`} element={<ClientTransactions />} />
          <Route path={`factures`} element={<Invoices />} />
          <Route path={`subscription`} element={<ClientSubscriptions />} />
          <Route path={`representants`} element={<ClientLegalRepresentatives />} />
      </Route>
      <Route path="ajout-client/*" element={<AddClientStepper />}>
        <Route index element={<StepEnterprise2 />} />
        <Route path=":id/*" >
          {CLIENT_ADD_STEPS.map((step, index) => (
            <Route
              key={step.id}
              path={step.pathName}
              element={<step.component />}
            />
          ))}
        </Route>


      </Route>
      {/*<Route path="modifier-client/:id" element={<AddClientStepper />}>*/}
      {/*  {CLIENT_ADD_STEPS.map((step, index) => (*/}
      {/*    <Route*/}
      {/*      key={step.id}*/}
      {/*      index={index === 0}*/}
      {/*      path={index === 0 ? undefined : step.pathName}*/}
      {/*      element={<step.component />}*/}
      {/*    />*/}
      {/*  ))}*/}
      {/*</Route>*/}
      <Route path="ajout-abonnement/*" element={<AddSubscriptionSteps />} />
    </Routes>
  )
}

export default ClientsRoutes
